import React from "react";

export interface RadioGroupOption {
  label: string;
  value: string | boolean;
}

interface RadioGroupProps {
  options: RadioGroupOption[];
  selectedValue: string | boolean;
  onChange: (option: RadioGroupOption | null) => void;
  direction?: "row" | "column";
}

function RadioGroup({
  options,
  selectedValue,
  onChange,
  direction = "column",
}: RadioGroupProps) {
  return (
    <div
      className={`flex ${direction === "row" ? "flex-row space-x-4 justify-between" : "flex-col space-y-2"}`}
    >
      {options.map((option, i) => (
        <label
          key={`${option.value}_${i}`}
          className={`
            group relative flex ${direction === "row" ? "flex-col items-center" : "items-center"}
            ${direction === "row" ? "flex-1" : "w-full"}
          `}
        >
          <div
            className={`
            ${
              direction === "row"
                ? "flex flex-col items-center justify-center w-full p-3 h-full"
                : "flex items-start w-full p-3"
            }
            rounded-md shadow-light cursor-pointer
            border border-electrum-200
            ${
              selectedValue === option.value
                ? "bg-electrum-100 border-electrum-250"
                : "bg-white hover:border-electrum-300 focus:border-electrum-300"
            }
            transition-colors duration-150
          `}
          >
            {direction === "row" ? (
              <>
                <div className="flex-shrink-0">
                  <input
                    type="radio"
                    value={String(option.value)}
                    checked={selectedValue === option.value}
                    onClick={() =>
                      onChange(selectedValue === option.value ? null : option)
                    }
                    onChange={() => {}}
                    className="
                      peer relative appearance-none shrink-0 w-6 h-6 ring-electrum rounded-full bg-electrum-100 shadow-light
                      focus:outline-none focus:ring-offset-0 focus:ring-1 focus:ring-electrum shadow-light
                      checked:bg-electrum checked:ring-1 shadow-light
                      disabled:ring-1 disabled:bg-[#FBFBFB] shadow-light
                    "
                  />
                </div>
                <span
                  className="text-center text-sm line-clamp-2 mt-2"
                  style={{
                    wordBreak: "break-word",
                    overflowWrap: "break-word",
                  }}
                >
                  {option.label}
                </span>
              </>
            ) : (
              <>
                <input
                  type="radio"
                  value={String(option.value)}
                  checked={selectedValue === option.value}
                  onClick={() =>
                    onChange(selectedValue === option.value ? null : option)
                  }
                  onChange={() => {}}
                  className="
                    peer relative appearance-none shrink-0 w-6 h-6 ring-electrum rounded-full bg-electrum-100 shadow-light
                    focus:outline-none focus:ring-offset-0 focus:ring-1 focus:ring-electrum shadow-light
                    checked:bg-electrum checked:ring-1 shadow-light
                    disabled:ring-1 disabled:bg-[#FBFBFB] shadow-light
                  "
                />
                <span
                  className="ml-3 text-base flex-1 min-w-0 leading-6"
                  style={{
                    wordBreak: "break-word",
                    overflowWrap: "break-word",
                  }}
                >
                  {option.label}
                </span>
              </>
            )}
          </div>
        </label>
      ))}
    </div>
  );
}

export default RadioGroup;
